import {fetchAndDeserialize} from '../../../util/api-adapter';
import {objectToUrlParameters} from '../../../util/url';
import {ReviewsAndAnswersFilterStateType} from '../filter/reviews-and-answers-statistics-filter-type';
import {reviewsAndAnswersApiFilterValues} from '../filter/reviews-and-answers-statistics-helper';

import {complaintsCountSchema, ComplaintsCountType} from './auto-abuses-count-type';

export function fetchAutoAbusesCount(
    filter: ReviewsAndAnswersFilterStateType,
    mainFilterKey: string
): Promise<ComplaintsCountType> {
    return fetchAndDeserialize(
        `/cp/reviews/statistics/auto_abuses/?${objectToUrlParameters(
            reviewsAndAnswersApiFilterValues(filter, mainFilterKey)
        )}`,
        complaintsCountSchema
    );
}
